<template>
    <div>
        <div class="componentContainer" >
            <div>
                <input type="button" class="mrr2 mrb5" @click="uploadJson()" value="保存" :disabled="Istate==0?false:true">
                <input type="button" class="mrr2 mrb5" @click="locationSave()" value="另存为" >
                <!--<input style='width: 173px;' type="file" id="upload_file" class="input">-->
                <!--<input type="button" @click="importXlsx" value="导入">-->
                <!--<input type="button" @click="savePdf" value="导出PDF">-->
                <input type="button" class="mrr2 mrb5" @click="cancel" value="取消">
            </div>
            <div id="spreadContainer_settlement" style="height: 550px">
<!--
                <gc-spread-sheets>
                        &lt;!&ndash;:hostClass='"spreadHost"'
                        @workbookInitialized='spreadInitHandle($event)'>&ndash;&gt;
                </gc-spread-sheets>
-->
            </div>
        </div>
    </div>

</template>

<script>
    import * as API from "./api"
    import spd from '../../../src/spreadJs/spreadview.js'
    import {baseerp} from "@/utils/baseUrl";
    import $ from 'jquery';

    // import ExcelIO from '@grapecity/spread-excelio'
    import FaverSaver from 'file-saver'
    //import s from './a.json'
    //import * as GC from '@grapecity/spread-sheets'
    //import '@grapecity/spread-sheets/styles/gc.spread.sheets.excel2016colorful.css'
    //import '@grapecity/spread-sheets-vue'
    //GC.Spread.Common.CultureManager.culture("zh-cn");
    //import '@grapecity/spread-sheets-resources-zh'
    //import  "@grapecity/spread-sheets-print";
    //import  "@grapecity/spread-sheets-pdf";
    //GC.Spread.Sheets.LicenseKey='';

    //import axios from 'axios';

    export default {
        name: "SheetData",
        components: {},
        props: {
            sheet: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                rowId:"",
                gsName:"",
                cTime:"",
                cjName:"",
                iType:"",
                fileId:"",
                Istate:'',
                Datas:{},
                fileName: "",
                excelIo: {},
                //spread: {},
                spreadStyle: {
                    width: '100%',
                    height: '70%'
                },
                filesdata:"",
                baseerp: "",
                hostClass:'spread-host',
                autoGenerateColumns:true,
                width:500,
                visible:true,
                resizable:true,
                formatter:"$ #.00",
                dataTable:[],
                ABC:[],
                filename:"",
                file_name:"",
                filenewname:"",
                rptJson:{},
                ccData:{},
                fid:"",
                mid:0,
            }
        },

        computed:{
            /*dataTable(){
                /!*let dataTable = [];
                for (let i = 0; i < 42; i++) {
                    dataTable.push({price: i + 0.56})
                }
                return dataTable*!/
            }*/
        },

        /*当数据没被销毁的情况下用监听，弹窗关闭后数据重加载 原数据已经没有 此时不需要用监听*/
        /*watch: {
            sheet: {
                handler() {
                    if (this.sheet) {
                        console.log(this.sheet,"从父级拿到");
                        this.Istate=this.sheet.i_state;
                       /!* //this.pageSize=this.page_size;
                        this.i_id = this.sheet.i_id;
                        this.mid = this.sheet.i_mid;
                        if (this.sheet.i_id == 0) {
                            this.getDateYYYYMMddHHMMSS();
                            this.title = this.sheet.title;
                            this.form = this.sheet.taskDa;
                            //this.formList=this.sheet.taskDa;
                            // console.log(this.sheet,this.title,this.form,"i_id",this.sheet.i_id)
                            this.sheetDetails = this.sheet.taskDa;
                            this.sheetDetails.i_mid = this.mid;
                            this.sheetDetails.selected=[];
                            this.edit = false;
                            this.chakan = false;
                            this.votevote = false;
                            this.commit = true;
                            this.formData = {
                                wtname: this.form.vc_outgsname,
                                gsname: this.form.vc_gsname,
                                bmname: this.form.vc_cjname,
                                num: "000000",
                                ckname: this.form.vc_ckname,
                                vc_pno: this.form.vc_pno,
                                vc_note: "",
                                vc_lruname: sessionStorage.getItem("lruname"),
                                date: this.date,
                                jftableData: [],
                                //xhtableData:[],
                                //sqname:sessionStorage.getItem("lruname"),
                            };
                        } else {
                            /!*if (this.feeding.title=="预览"){
                                this.chakan=true;
                            }else {
                                this.chakan=false;
                            }*!/
                            //编辑
                            this.votevote = true;
                            this.edit = true;
                            this.isbtn = true;
                            this.editForm = this.sheet.value;
                            this.getvoid=this.editForm.i_state==0?false:true;
                            this.form = this.sheet.taskDa;
                            this.title = this.sheet.title;
                            this.commit = this.editForm.i_state != 0 ? true : false;
                            // console.log(this.sheet,this.title,this.form,this.editForm,"i_id",this.sheet.i_id)
                            this.formData = {
                                wtname: this.form.vc_outgsname,
                                gsname: this.form.vc_gsname,
                                bmname: this.form.vc_cjname,
                                num: "000000",
                                ckname: this.form.vc_ckname,
                                vc_pno: this.form.vc_pno,
                                vc_note: this.editForm.vc_note,
                                vc_lruname: sessionStorage.getItem("lruname"),
                                date: this.editForm.dt_createtime,
                                jftableData: [],
                                // xhtableData:[],
                                // sqname:sessionStorage.getItem("lruname"),
                            };
                            //调点击编辑查看交付单时调用的接口
                            this.getOutputDetails();*!/
                        }
                    }
                },
                immediate: true,
                deep: true
            },*/


        mounted() {
            //console.log($('.spreadContainer'));
            this.baseerp=baseerp;
            this.Datas=this.sheet.value;
            this.rowId=this.sheet.i_id;
            this.mid=this.sheet.i_mid;
            this.cTime=this.sheet.timeData;
            this.dataTime=this.sheet.dataTime;
            this.pageSize=this.sheet.page_size;
            this.Istate=this.Datas.i_state;
            this.iType=this.Datas.i_type;
            this.cjName=this.F=this.Datas.vc_cjname;
            this.gsName=this.Datas.vc_gsnameshort;
            this.ccData=this.Datas.jsParam;
            //console.log(this.mid,"mid");
            //this.fid=this.Datas.fid;
            //console.log(this.Datas.fid,this.ccData,this.pageSize,this.sheet,this.Datas,"拿到父值");
            spd.setWorkBook($('#spreadContainer_settlement'));
            let arg={
                fid:this.Datas.fid,
                filename:this.Datas.fid,
                type:'view',
                /*arg:{
                    "jssj":'202112',
                    "cjid":'625',
                    "type":'1',
                },*/
                arg:this.ccData,
                //sn:0,
            };
            //console.log(arg,"arg111111111111");
            spd.loadRpt(arg);
        },
        methods: {
            //保存接口
            async saveStatistics(){
                let param = {
                    i_mid:this.mid,
                    i_cjid:this.Datas.i_cjid,
                    i_ckid:this.Datas.i_ckid,
                    i_gsid:this.Datas.i_gsid,
                    i_gsid_out:this.Datas.i_gsid_out,
                    i_type:this.iType,
                    dt_createtime:this.Datas.dt_createtime,
                    fileId:this.fileId,
                    i_id:this.rowId,
                };
                let res = await API.saveStatistics(param);
                if (res.code == 1) {
                    let value={
                        pageSize:this.pageSize,

                };
                    this.$message.success(res.message);
                    this.$emit('getStatisticsList',value);
                    this.$emit('close');
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            ///上传附件接口（回调保存接口）
            uploadJson(){
                let ex = spd.excelIO_spd;
                //console.log(ex,"exexexexxxxx");
                let json =spd.spread.toJSON({includeBindingSource:true});
                const that=this;
                ex.save(json, async function (blob) {
                    //console.log(blob,"blob");
                    FaverSaver.saveAs(blob, 'export.xlsx');
                    //console.log(that.cTime+that.gsName+that.cjName+that.filename+".xls","fileeeeeeee");
                    let newFiles = new window.File([blob], that.cTime+that.gsName+that.cjName+that.filename+".xls", {type: 'xls'});
                    let param = {
                        "IDtype": "",
                        "style": "settlementReport",
                        files:newFiles,
                        i_appid:0,
                        vc_app: "settlementReport",
                    };
                    //console.log(param,"param");
                    let res = await API.upload(param);
                    if (res.code == 1) {
                        that.fileId=res.data[0].i_id;
                        that.file_name=res.data[0].filename;
                        that.filenewname=res.data[0].filenewname;
                        //console.log(that.fileId,that.file_name,that.filenewname,"res.data")
                        ///调保存接口
                        that.saveStatistics();
                        //that.$message.success(res.message);
                    } else if (res.code == -2) {
                        that.$router.push('/login');
                        that.$message.error(res.message);
                    }else{
                        that.$message.error(res.message);
                    }
                }, function (e) {
                    //console.log(e,"12345")
                });
                //console.log(ex.save,"save");
            },

            //另存为（本地保存）
            locationSave(){
                let ex = spd.excelIO_spd;
                //console.log(spd,"spd");
                //console.log(ex,"ex");
                let json =spd.spread.toJSON({includeBindingSource:true});
                //console.log(json,"json");
                const that=this;
                ex.save(json, function (blob) {
                    //console.log(blob,"blob");
                    FaverSaver.saveAs(blob, 'export.xlsx');
                    //console.log(that.cTime+that.gsName+that.cjName+that.filename+".xls","fileeeeeeee");
                   //let newFiles = new window.File([blob], that.cTime+that.gsName+that.cjName+that.filename+".xls", {type: 'xls'});
                    /*let param = {
                        "IDtype": "",
                        "style": "settlementReport",
                        files:newFiles,
                        i_appid:0,
                        vc_app: "settlementReport",
                    };
                    //console.log(param,"param");
                    let res = await API.upload(param);
                    if (res.code == 1) {
                        that.fileId=res.data[0].i_id;
                        that.file_name=res.data[0].filename;
                        that.filenewname=res.data[0].filenewname;
                        //console.log(that.fileId,that.file_name,that.filenewname,"res.data")
                        ///调保存接口
                        ///that.saveStatistics();
                        //that.$message.success(res.message);
                    } else if (res.code == -2) {
                        that.$router.push('/login');
                        that.$message.error(res.message);
                    }else{
                        that.$message.error(res.message);
                    }*/
                }, function (e) {
                    //console.log(e,"12345")
                });
                //console.log(ex.save,"save");
            },

            //loadDataFromSvr接口
            /*async loadDataFromSvr(){
                var sheet = this.spread.getActiveSheet();
                //var parm=rptJson.set.parm;
                //var a = {};
                /!*for(var i = 0; i < parm.length; i++){
                    a[parm[i].name]=$("input#inp_parm_"+parm[i].name)[0].value;
                }*!/
                let param = {
                    filename:'202201114628065d07da4a77621450aa84fee5656d9',
                    type:'data',
                    arg:{"jssj":"202112 ","cjid":"625","type":"1"},
                    sn:0,
                };
                let res = await jUtil.loadDataFromSvr(param);
                console.log(res,"res");

                if (res) {

                    //let a =JSON.parse(res);
                    console.log(res ,"aaaaaaa")
                    //console.log(a,"aaaaaaaaaaa");
                    //this.spread = spread;
                    //this.spread.fromJSON(res);
                    /!*实现表单保护，设置了sheet每个单元格都不能编辑*!/
                    let sheet = this.spread.getActiveSheet();
                    sheet.options.isProtected = true;
                    let defaultStyle = sheet.getDefaultStyle();
                    defaultStyle.locked = true;//设置locked默认为true

                    console.log(jUtil,res,this.spread.getActiveSheetIndex(),"123");
                    jUtil.beforeLoadData(this.spread,res,this.spread.getActiveSheetIndex());

                    /!*window.setTimeout(function () {
                        //hideLoading();
                        try {
                            jUtil.beforeLoadData(data,this.spread.getActiveSheetIndex());
                        } catch (ex) {
                        }
                    }, 600);*!/

                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    //this.$message.error(res.message);
                }else{
                    //this.$message.error(res.message);
                }
            },*/

            //download接口
            /*async download(){
            let param = {
                fid:'202201114628065d07da4a77621450aa84fee5656d9',
            };
            let res = await API.download(param);
            if (res.code == 1) {
                this.filename=res.data.filename;
                this.filesdata=JSON.parse(res.data.file_json);
                //console.log(that.filesdata,"that.filedata")
                console.log(this.filesdata,this.filename,"this.spread.fromJSON(s)");
                //this.spread = spread;
                this.spread.fromJSON(this.filesdata);
                /!*实现表单保护，设置了sheet每个单元格都不能编辑*!/
                let sheet = this.spread.getActiveSheet();
                sheet.options.isProtected = true;
                let defaultStyle = sheet.getDefaultStyle();
                defaultStyle.locked = true;//设置locked默认为true

                //this.loadDataFromSvr();


               /!* //loadDataFromSvr接口
                jUtil.loadDataFromSvr(this.spread,param);
                console.log(jUtil.loadDataFromSvr(this.spread,param),"ABC");*!/

                //this.tableData=res.data;
                //this.tableTotal=res.count;
                // this.$nextTick(function() {
                //     this.$refs.deliverlight.setCurrentRow(this.tableData[val.row])
                // });
                //console.log(this.tableData,"this.tableData");
                //this.$message.success(res.message);
            } else if (res.code == -2) {
                this.$router.push('/login');
                this.$message.error(res.message);
            }else{
                this.$message.error(res.message);
            }
        },*/

            //关闭
            cancel() {
                //console.log(this.pageSize,"------")
                this.$emit('close');
                },


            /*//调用filesget接口
            getlist(){
               const that=this;
                console.log(this.filesdata+"test","filesdata")
                    axios.get('./e.json').then(function (res) {
                        //console.log(res.data,res.data.data.file_json,"getlist");
                        this.filesdata=JSON.parse(res.data.data.file_json);
                        //console.log(that.filesdata,"that.filedata")
                    })
                },*/
            /*async filesget(){
                let param = {
                    fid:"20201203203839ab46820b524afda05122893c2fe8e"
                };
                let res = await API.filesget(param);
                if (res.code == 1) {
                    this.filesdata=JSON.parse(res.data.file_json);
                    console.log(this.filesdata,"this.filesdata")
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },*/

            //加载报表
            spreadInitHandle: function (spread) {
                //console.log(spread,"this.spread")
                const that=this;
                that.spread = spread;
                //that.download();
                //先调download接口，在回调函数里调getFormJsonData（在loadDataFromSvr修改）
                /*//loadDataFromSvr接口
                jUtil.loadDataFromSvr(spread);
                console.log(jUtil.loadDataFromSvr(spread),"ABC");*/
                /*axios.get('./e.json').then(function (res) {
                    //console.log(res.data,res.data.data.file_json,"getlist");
                    that.filesdata=JSON.parse(res.data.data.file_json);
                    //console.log(that.filesdata,"that.filedata")
                    console.log(that.filesdata,"this.spread.fromJSON(s)");
                    that.spread = spread;
                    that.spread.fromJSON(that.filesdata);

                    /!*实现表单保护，设置了sheet每个单元格都不能编辑*!/
                    let sheet = spread.getActiveSheet();
                    sheet.options.isProtected = true;
                    let defaultStyle = sheet.getDefaultStyle();
                    defaultStyle.locked = true;//设置locked默认为true
                })*/
            },

            exportXlsx () {
                //只需要拿到json
                let ex = spd.ExcelIO_spd;
                let json = this.spread.toJSON();
                //console.log(ex,json,"IO");
                ex.save(json, function (blob) {
                    FaverSaver.saveAs(blob, 'export.xlsx')
                }, function (e) {
                    //console.log(e,"12345")
                });
                ///调保存接口
            },

            /*importXlsx(){
                let self = this;
                var excelIO = new ExcelIO.IO();
                console.log(excelIO,"excelIO");
                const excelFile = document.getElementById("fileDemo").files[0];
                excelIO.open(excelFile, function (json) {
                    let workbookObj = json;
                    self.spread.fromJSON(workbookObj);
                }, function (e) {
                    alert(e.errorMessage);
                });
            },*/

            /*savePdf(){
                let self = this;
                let jsonString = JSON.stringify(self.spread.toJSON());
                let printSpread = new GC.Spread.Sheets.Workbook();
                printSpread.fromJSON(JSON.parse(jsonString));

                printSpread.savePDF(function(blob) {
                    // window.open(URL.createObjectURL(blob))
                    FaverSaver.saveAs(blob,  'Hello.pdf')
                }, function(error) {
                    console.log(error);
                }, {
                    title: 'Print',
                });
            }*/


            ///////////////////

            //上传EXCEL
            upExcel(){
                var excelFile = document.getElementById("upload_file").files[0];
                this.excelIo.open(excelFile, (json) => {
                    var workbookObj = json;
                    this.spread.fromJSON(workbookObj);
                }, function (e) {
                    alert('文件读取失败，仅支持xlsx类型');
                });
            },

            //选择文件
            selectExcel(){
                upload_file.click();
            },
            changeExcel(){
                var excelFile = document.getElementById("upload_file").files[0];
                this.fileName = document.getElementById("upload_file").files[0].name;
                //this.upExcel();
            },

            //保存EXCEL
            saveExcel(){
                //生成时间戳
                var fileName = new Date().getTime() + '.xlsx';
                var json = this.spread.toJSON();
                this.excelIo.save(json, (blob) => {
                    saveAs(blob, fileName);
                }, function (e) {
                    //console.log(e);
                });
            },

            //保存模板
            saveTemplate(){
                //生成时间戳
                var fileName = new Date().getTime() + '.json';
                var json = this.spread.toJSON();
                var jsontext = JSON.stringify(json);
                //前台保存
                saveAs(new Blob([jsontext], {type: "text/plain;charset=utf-8"}), fileName);
                //保存后台
                let formData = new FormData();
                // var thefile = document.getElementById("upload_file").files[0];
                var thefile = this.filesdata.version;
                formData.append("file", thefile);
                //formData.append("fileName", thefile.name);
                //console.log(thefile,formData,"存后台");
                axios.post('/admin/excelup/doImport', formData).then(function (response) {
                    alert("模板保存成功");
                }).catch(function (error) {
                    alert("上传失败");
                    //console.log(error);
                });

            },


        },
    }
</script>

<style lang="scss" scoped>


    .componentContainer {
        //position: absolute;
        //padding: 10px;
        left: 242px;
        top: 0;
        bottom: 20px;
        right: 0;
    }
    .spreadContainer {
        padding: 10px;
        box-shadow: 0 0 20px grey;
    }
    .spreadContainer{
        //position: absolute;
        height: 500px;
        left: 0px;
        right: 30px;
        top: 100px;
        bottom: 10px;
    }

    .spread-host {
        width: 500px;
        height: 600px;
    }

    .flex{
        justify-content: left;
    }

    .fr{
        float: right;
    }

    .mrt20{
        margin-top: 20px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrb5{
        margin-bottom: 5px;
    }

    .mrr2{
        margin-right: 8px;
    }



    /deep/{

        .el-dialog__body{
            word-break:unset;

        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 15px;
        }

    }

</style>